export default "__VITE_ASSET__Dec2sZ4Q__"